import React , { useState,useEffect } from 'react';
import webapi from '../../../api/webapi';
//import Parsiglogopng from '../../images/logo.png'
import ParsiglogoFooterpng from '../../images/logoFooter.png'
import ParsiglogoFooterpng2 from '../../images/0101-FINAL.png'
import Parsiguparrowpng from '../../images/up-arrow.png'

//import Parsigpazhouheshgahpng from '../../images/02.png'
//import jpeg2 from '../../images/01.png'
//import Parsigashajpeg from '../../images/03.png'
//import packageJson from '../../../../package.json';

const Footer = (props) => {

    const [visitData,setVisitData] = useState(undefined)
    //const [lang,setLang] = useState(undefined)    
    const [pageData,setPageData] = useState(undefined)  

    useEffect(() => {
        async function fetchData() {
            //setLoadingShow(true);

            //const resVisitList = await webapi.get('pages/visit');
                
            //setVisitData(resVisitList.data);

            var langVar = 'fa';

            if (props.lang)
            {
                langVar = props.lang;
            }else{
                langVar = 'fa';
            }
            
            //setLang(langVar);

            if (langVar !== undefined)
            {
                const pageList = await webapi.get('pages/datapages/9/'+langVar);
                //console.log(pageList);
                setPageData(pageList.data)
            }else{
                const pageList = await webapi.get('pages/datapages/9/fa');
                //console.log(pageList);
                setPageData(pageList.data)                    
            }

            //setLoadingShow(false);
        }
        fetchData();
    }, [props.lang]);

    if (pageData) {
        return (
            <div className="absolute">
                <div className="container-fluid" id="footer_container_fluid">
                    <div className="container">
                        <div id="footer_1">
                            <img alt="logo" src={ParsiglogoFooterpng} />
                            <img alt="logo" src={ParsiglogoFooterpng2} />
                            {/* <div style={{textAlign:'center'}}>
                                ver:{packageJson.version}
                            </div> */}
                            {/* <div id="columns">
                                <div className="column">
                                    <a href="http://www.ihcs.ac.ir/fa" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigpazhouheshgahpng} /></a>
                                </div>
                                <div className="column">
                                    <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigashajpeg} /></a>
                                </div>
                                <div className="column">
                                    <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={jpeg2} /></a>
                                </div>
                            </div> */}
                        </div>
                        {/* <div id="footer_2">
                        <h6>دسترسی سریع</h6>
                        <ul>
                            <li>
                            <a href="/aboutus">درباره پایگاه دادگان پارسیگ</a>
                            </li>
                            <li>
                            <a href="/help_search">راهنمای جستجو در پایگاه</a>
                            </li>
                            <li>
                            <a href="/help_tags">جدول برچسب های دستوری</a>
                            </li>
                            <li>
                            <a href="/library_res">منابع پایگاه</a>
                            </li>
                            <li>
                            <a href="/library_signs">علایم اختصاری کتاب ها</a>
                            </li>
                            <li>
                            <a href="/library_art">مقالات مرتبط</a>
                            </li>
                        </ul>
                        </div> */}
                        <div id="footer_3">
                        <h6>{pageData.length!==0 && pageData[0].F902!== undefined?pageData[0].F902:902/*پیوندها*/}</h6>
                        <ul>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="http://pldb.ihcs.ac.ir/">{pageData.length!==0 && pageData[0].F90201!== undefined?pageData[0].F90201:90201/*پایگاه دادگان زبان فارسی*/}</a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="http://pahlavazh.ihcs.ac.ir/">{pageData.length!==0 && pageData[0].F90202!== undefined?pageData[0].F90202:90202/*فرهنگ واژه‌های فارسی میانه-فارسی نو (پهلواژ)*/}</a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="http://titus.uni-frankfurt.de/">{pageData.length!==0 && pageData[0].F90203!== undefined?pageData[0].F90203:90203/*تزاروس زبان‎های هندواروپایی و مواد متنی (تیتوس)*/}</a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="http://pahlavica.org/">{pageData.length!==0 && pageData[0].F90204!== undefined?pageData[0].F90204:90204/*دایره‌المعارف فارسی میانه (پهلویکا)*/}</a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="https://ada.geschkult.fu-berlin.de/">{pageData.length!==0 && pageData[0].F90205!== undefined?pageData[0].F90205:90205/*آرشیو دیجیتال متون اوستایی*/}</a>
                            </li>
                        </ul>
                        </div>
                        <div id="footer_4">
                        {
                            (visitData)
                            ?
                            <div>
                                    <h6>
                                        {pageData.length!==0 && pageData[0].F901!== undefined?pageData[0].F901:901/*آمار سایت*/}
                                    </h6>
                                <ul>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90101!== undefined?pageData[0].F90101:90101/*کاربران آنلاین*/}: {/*VisitData[0].OnLine*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90102!== undefined?pageData[0].F90102:90102/*بازدیدهای امروز*/}: {/*VisitData[0].ThisDay*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90103!== undefined?pageData[0].F90103:90103/*بازدیدهای ماه گذشته*/}: {/*VisitData[0].ThisMonth*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90104!== undefined?pageData[0].F90104:90104/*تمام بازدیدها*/}: {/*VisitData[0].AllVisits*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90105!== undefined?pageData[0].F90105:90105/*جستجوهای امروز*/}: {/*VisitData[0].ThisDaySearches*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90106!== undefined?pageData[0].F90106:90106/*جستجوهای ماه گذشته*/}: {/*VisitData[0].ThisMonthSearches*/}
                                    </li>
                                    <li>
                                        {pageData.length!==0 && pageData[0].F90107!== undefined?pageData[0].F90107:90107/*تمام جستجوها*/}: {/*VisitData[0].AllSearches*/}
                                    </li>
                                </ul>
                                </div>
                                :
                                null
                        }
                        </div>
                    </div>
                    </div>
                    <div className="container-fluid" id="footer_bottom">
                    <div className="container">
                        <p>{pageData.length!==0 && pageData[0].F90901!== undefined?pageData[0].F90901:90901/*استفاده از داده‌های این سایت با ذکر منبع بلامانع است.*/}</p>
                        <p className="left_align" style={{textAlign:"center"}}>{pageData.length!==0 && pageData[0].F90902!== undefined?pageData[0].F90902:90902/*©2020 Pārsīgdatabase. All Rights Reserved.*/}</p>
                        <img alt="up" src={Parsiguparrowpng} id="scroll_to_top" />
                        
                    </div>
                </div>
                
            </div>
        )
    }
    else
        return null;
}

export default Footer;        